
import React, { useEffect, useState } from "react";

function CartPage() {
  const [cart, setCart] = useState([]);

  // 🔹 Load cart on page load
  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem("cart")) || [];
    setCart(storedCart);
  }, []);

  // 🔹 Update cart helper
  const updateCart = (newCart) => {
    setCart(newCart);
    localStorage.setItem("cart", JSON.stringify(newCart));
  };

  // 🔹 Increase quantity
  const increaseQty = (id) => {
    updateCart(
      cart.map((item) =>
        item.id === id
          ? { ...item, quantity: item.quantity + 1 }
          : item
      )
    );
  };

  // 🔹 Decrease quantity (min 1)
  const decreaseQty = (id) => {
    updateCart(
      cart.map((item) =>
        item.id === id && item.quantity > 1
          ? { ...item, quantity: item.quantity - 1 }
          : item
      )
    );
  };

  // 🔹 Remove item
  const removeItem = (id) => {
    updateCart(cart.filter((item) => item.id !== id));
  };

  // 🔹 BUY NOW (single product)
  const handleBuyNow = (item) => {
    localStorage.setItem("checkoutProduct", JSON.stringify(item));
    window.location.href = "/userdashboard/checkout";
  };

  // 🔹 Grand total
  const grandTotal = cart.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  return (
    <div style={{ padding: "20px", maxWidth: "800px", margin: "auto" }}>
      <h2>🛒 My Cart</h2>

      {cart.length === 0 && <p>Cart is empty 😕</p>}

      {cart.map((item) => (
        <div
          key={item.id}
          style={{
            border: "1px solid #ccc",
            borderRadius: "10px",
            padding: "15px",
            marginBottom: "15px",
          }}
        >
          <img
            src={item.images?.[0]}
            alt={item.name}
            style={{
              width: "120px",
              height: "120px",
              objectFit: "cover",
              borderRadius: "10px",
            }}
          />

          <h4>{item.name}</h4>
          <p>Price: ₹{item.price}</p>

          {/* Quantity controls */}
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <button onClick={() => decreaseQty(item.id)}>−</button>
            <strong>{item.quantity}</strong>
            <button onClick={() => increaseQty(item.id)}>+</button>
          </div>

          <p>
            <strong>Total: ₹{item.price * item.quantity}</strong>
          </p>

          {/* Action buttons */}
          <div style={{ display: "flex", gap: "10px" }}>
            <button
              onClick={() => handleBuyNow(item)}
              style={{
                background: "#007bff",
                color: "white",
                border: "none",
                padding: "8px 14px",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              ⚡ Buy Now
            </button>

            <button
              onClick={() => removeItem(item.id)}
              style={{
                background: "red",
                color: "white",
                border: "none",
                padding: "8px 14px",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              ❌ Remove
            </button>
          </div>
        </div>
      ))}

      {cart.length > 0 && (
        <h3 style={{ textAlign: "right" }}>
          🧾 Grand Total: ₹{grandTotal}
        </h3>
      )}
    </div>
  );
}

export default CartPage;

